import { createAction } from '../../../store.model';
import { ActionType } from '../focus-selector.action';
import { FocusSelectorMetricModel } from '../model/focus-selector-metric.model';

export interface FocusSelectorSelectActiveMetric {
    activeMetricId: FocusSelectorMetricModel['id'];
}

export const focusSelectorSelectActiveMetric = createAction<
    ActionType,
    FocusSelectorSelectActiveMetric
>(ActionType.COACHING_FOCUS_SELECTOR__SELECT_ACTIVE_METRIC);

export interface FocusSelectorSelectMetricRow {
    metricRowId: FocusSelectorMetricModel['id'];
}

export const focusSelectorSelectMetricRow = createAction<
    ActionType,
    FocusSelectorSelectMetricRow
>(ActionType.COACHING_FOCUS_SELECTOR__SELECT_METRIC_ROW);
